import QuickOption from "../components/QuickOption";
import RecentActivity from "../components/RecentActivity";
import LatestAnggaran from "../components/LatestAnggaran";
import { Container, Row } from "reactstrap";
import React, { Fragment, useState } from "react";
import Announcement from "../components/Announcement";
import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import TotalChart from "../components/TotalChart";
import { admins } from "../../../Constant";
import { getUser } from "../../../Utils/externalFunctions";
import TotalStackChart from "../components/TotalStackChart";
import useAxios from "../../../Utils/useAxios";
import RealisasiChart from "../components/RealisasiChart";
import getAngganranBUK from "../services/getAnggaranBUK";

const DefaultContain = () => {
  const isAdmin = admins.includes(getUser());
  const axiosInstance = useAxios();

  const [updatedAnggaranBUK, setUpdatedAnggaranBUK] = useState([]);

  // const [pending, setPending] = useState(true);

  let isMounted = true;
  useEffect(() => {
    const username = localStorage.getItem("username");
    if (username === null) {
      localStorage.removeItem("authTokens");
      <Navigate to="/signin" />;
    } else {
      isMounted && getAnggaranBulanan();
    }

    return () => {
      isMounted = false;
    };
  }, []);

  const getAnggaranBulanan = () => {
    getAngganranBUK(axiosInstance).then((res) => {
      setUpdatedAnggaranBUK(res.data);
      // setPending(false);
    });
  };

  return (
    <Fragment>
      <Container fluid={true} className="default-dash">
        <Row>
          <QuickOption xs="12" className="box-col dash-chat" />
          {isAdmin && (
            <TotalStackChart
              updatedanggaranbuklist={updatedAnggaranBUK}
              xs="12"
              className="box-col dash-chat"
            />
          )}
          {isAdmin && (
            <TotalChart
              updatedanggaranbuklist={updatedAnggaranBUK}
              xs="12"
              className="box-col dash-chat"
            />
          )}
          {isAdmin && (
            <RealisasiChart
              updatedanggaranbuklist={updatedAnggaranBUK}
              xl="6"
              lg="12"
              md="12"
              className="des-md-45 xl-50 des-xl-45 box-col-6 dash-chat"
            />
          )}
          <LatestAnggaran
            updatedanggaranbuklist={updatedAnggaranBUK}
            xl="6"
            lg="12"
            md="12"
            className="des-md-45 xl-50 des-xl-45 box-col-6 dash-chat"
          />
          <Announcement
            xl="6"
            lg="12"
            md="12"
            className="des-md-50 des-xl-50 xl-50 box-col-6"
          />
          {isAdmin && (
            <RecentActivity
              xl="6"
              lg="12"
              md="12"
              className="des-md-45 xl-50 des-xl-45 box-col-6 dash-chat"
            />
          )}
        </Row>
      </Container>
    </Fragment>
  );
};
export default DefaultContain;
